export default __webpack_public_path__ + "static/media/ubuntu_regular.1cbb1b79.ttf";